import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { getDocuments } from '../actions/getDocuments';

type GetDocumentsParams = {
  sort?: string;
  orderBy?: string;
  limit?: string;
  offset?: string;
  search?: string;
};

const getDocumentsQueryKey = (params: GetDocumentsParams) => [
  'documents',
  params,
];

export const getDocumentsQueryOptions = (params: GetDocumentsParams) =>
  queryOptions({
    queryKey: getDocumentsQueryKey(params),
    staleTime: 0, // always fetch fresh data

    placeholderData: keepPreviousData, // don't have 0 rows flash while changing pages/loading next page
    queryFn: async () => {
      const response = await getDocuments({
        data: params,
      });

      if (!response.success || response.error) {
        throw new Error(response.error || 'Unknown error');
      }

      return response.data;
    },
  });

export const useGetDocuments = (params: GetDocumentsParams) =>
  useQuery(
    getDocumentsQueryOptions({
      sort: params.sort,
      orderBy: params.orderBy,
      limit: params.limit,
      offset: params.offset,
      search: params.search,
    })
  );
